export const FORMATIONS = {
  '4-3-3': [
    { label: 'GOL', x: 50, y: 92 },
    { label: 'LE', x: 15, y: 72 },
    { label: 'ZAE', x: 38, y: 75 },
    { label: 'ZAD', x: 62, y: 75 },
    { label: 'LD', x: 85, y: 72 },
    { label: 'MEE', x: 28, y: 50 },
    { label: 'VOL', x: 50, y: 54 },
    { label: 'MED', x: 72, y: 50 },
    { label: 'PE', x: 15, y: 25 },
    { label: 'ATA', x: 50, y: 18 },
    { label: 'PD', x: 85, y: 25 }
  ],
  '4-4-2': [
    { label: 'GOL', x: 50, y: 92 },
    { label: 'LE', x: 15, y: 72 },
    { label: 'ZAE', x: 38, y: 75 },
    { label: 'ZAD', x: 62, y: 75 },
    { label: 'LD', x: 85, y: 72 },
    { label: 'ME', x: 15, y: 48 },
    { label: 'MEE', x: 38, y: 50 },
    { label: 'MED', x: 62, y: 50 },
    { label: 'MD', x: 85, y: 48 },
    { label: 'ATE', x: 38, y: 18 },
    { label: 'ATD', x: 62, y: 18 }
  ],
  '4-2-3-1': [
    { label: 'GOL', x: 50, y: 92 },
    { label: 'LE', x: 15, y: 72 },
    { label: 'ZAE', x: 38, y: 75 },
    { label: 'ZAD', x: 62, y: 75 },
    { label: 'LD', x: 85, y: 72 },
    { label: 'VOLE', x: 35, y: 56 },
    { label: 'VOLD', x: 65, y: 56 },
    { label: 'PE', x: 18, y: 32 },
    { label: 'MEI', x: 50, y: 35 },
    { label: 'PD', x: 82, y: 32 },
    { label: 'ATA', x: 50, y: 15 }
  ],
  '3-5-2': [
    { label: 'GOL', x: 50, y: 92 },
    { label: 'ZAE', x: 28, y: 75 },
    { label: 'ZAG', x: 50, y: 75 },
    { label: 'ZAD', x: 72, y: 75 },
    { label: 'ME', x: 12, y: 48 },
    { label: 'MEE', x: 32, y: 50 },
    { label: 'VOL', x: 50, y: 52 },
    { label: 'MED', x: 68, y: 50 },
    { label: 'MD', x: 88, y: 48 },
    { label: 'ATE', x: 38, y: 18 },
    { label: 'ATD', x: 62, y: 18 }
  ],
  '4-1-2-1-2': [
    { label: 'GOL', x: 50, y: 92 },
    { label: 'LE', x: 15, y: 72 },
    { label: 'ZAE', x: 38, y: 75 },
    { label: 'ZAD', x: 62, y: 75 },
    { label: 'LD', x: 85, y: 72 },
    { label: 'VOL', x: 50, y: 60 },
    { label: 'MEE', x: 32, y: 44 },
    { label: 'MED', x: 68, y: 44 },
    { label: 'MEI', x: 50, y: 28 },
    { label: 'ATE', x: 38, y: 14 },
    { label: 'ATD', x: 62, y: 14 }
  ]
};
